import { useQuery } from "@tanstack/react-query";
import { QUERY_CONSTANTS } from "../queryKeys";
import { IPaginationParams } from "../types";
import { IContractForAssign, IContractForTable } from "../../models/Contract";
import { ContractService } from "../../services/contract.service";

export const useGetContractsQuery = (data: IPaginationParams) => {
  return useQuery<{ data: IContractForTable[]; totalCount: number }, Error>({
    queryKey: [QUERY_CONSTANTS.GET_CONTRACTS, data],
    queryFn: () => ContractService.getAll(data.currentPage, data.pageSize).then((res) => res.data),
  });
};

export const useGetContractForAssignQuery = () => {
  return useQuery<IContractForAssign[], Error>({
    queryKey: [QUERY_CONSTANTS.GET_CONTRACTS_FOR_ASSIGN],
    queryFn: () => ContractService.getAllForAssign().then((res) => res.data),
  });
};
